module.exports = {"140405100":"麟绛镇","140405101":"上村镇","140405102":"渔泽镇","140405103":"余吾镇","140405104":"吾元镇","140405105":"张店镇","140405106":"丰宜镇","140405200":"李高乡","140405201":"路村乡","140405202":"河神庙乡","140405203":"西贾乡","140405400":"西流寨开发区","140405401":"康庄工业园区","140405402":"上莲开发区","140405403":"屯留县经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140405.json
// module id = 293
// module chunks = 0